import { Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";

export const WeedingPass = ({ weedingPass, message }) => {
  return (
    <>
      <Row>
        <Col sm={4} className="col-12">
          <OverlayTrigger placement="top" overlay={<Tooltip>{message}</Tooltip>}>
            <Card>
              <Card.Header>
                <h3 className="card-title mb-0">Weeding Pass</h3>
              </Card.Header>
              <Card.Body>
                <div className="table-responsive">
                  <Table className="table text-nowrap text-md-nowrap mg-b-0">
                    <tbody>
                      {
                        (weedingPass.adults || 0) > 0 &&
                        <tr >
                          <td>Adultos</td>
                          <td>{weedingPass.adults}</td>
                        </tr>
                      }
                      {
                        (weedingPass.juniors || 0) > 0 &&
                        <tr >
                          <td>Juniors</td>
                          <td>{weedingPass.juniors}</td>
                        </tr>
                      }
                      {
                        (weedingPass.minors || 0) > 0 &&
                        <tr >
                          <td>Menores</td>
                          <td>{weedingPass.minors}</td>
                        </tr>
                      }
                      {
                        (weedingPass.infants || 0) > 0 &&
                        <tr >
                          <td>Infantes</td>
                          <td>{weedingPass.infants}</td>
                        </tr>
                      }
                      <tr style={{ fontWeight: "bold" }}>
                        <td>Total</td>
                        <td>{(weedingPass.adults || 0) + (weedingPass.juniors || 0) + (weedingPass.minors || 0) + (weedingPass.infants || 0)}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </OverlayTrigger>
        </Col>
      </Row>
    </>
  )
}
